import * as React from 'react';

function ArrowRight(props) {
	return (
		<svg width='9' height='14' viewBox='0 0 9 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M1.69156 12.3848L7.07617 7.00015L1.69156 1.61553'
				stroke='#153c4f'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default ArrowRight;
